import { Bundles } from '../../util/moduleLoader';

import useModuleLoader from '../../hooks/useModuleLoader';

import Loading from '../ui/Loading';

const AuthBotTokenAsync = () => {
  const AuthBotToken = useModuleLoader(Bundles.Auth, 'AuthBotToken');

  return AuthBotToken ? <AuthBotToken /> : <Loading />;
};

export default AuthBotTokenAsync;
